export var TopLevelRegion;
(function (TopLevelRegion) {
    TopLevelRegion["EMEA"] = "EMEA";
    TopLevelRegion["AMER"] = "AMER";
    TopLevelRegion["APAC"] = "APAC";
    TopLevelRegion["Unspecified"] = "unspecified";
})(TopLevelRegion || (TopLevelRegion = {}));
export const regionOptions = Object.values(TopLevelRegion)
    .filter((value) => value !== TopLevelRegion.Unspecified)
    .map((v) => ({
    label: v,
    value: v,
}));
//# sourceMappingURL=TopLevelRegion.js.map